import Phaser from "phaser";
import { AssetKeys } from "../core/AssetKeys";

export class TitleScene extends Phaser.Scene {
  constructor() {
    super("TitleScene");
  }

  create(): void {
    const width = this.scale.width;
    const height = this.scale.height;

    const background = this.add.image(width / 2, height / 2, AssetKeys.TitleBackground);
    background.setDisplaySize(width, height);

    this.add.rectangle(0, 0, width, height, 0x020407, 0.46).setOrigin(0);
    this.add.rectangle(width / 2, 0, width, 310, 0x000000, 0.28).setOrigin(0.5, 0);

    this.add.text(width / 2, 210, "ARCANE DEPTHS", {
      fontFamily: "Georgia, serif",
      fontSize: "88px",
      color: "#e7dfcf",
      letterSpacing: 8,
    }).setOrigin(0.5);

    this.add.rectangle(width / 2, 286, 250, 1, 0xb49760, 0.7);

    this.add.text(width / 2, 326, "VOICE SPELL ARENA", {
      fontFamily: "Arial, sans-serif",
      fontSize: "18px",
      color: "#b9ad98",
      letterSpacing: 6,
    }).setOrigin(0.5);

    const start = this.add.text(width / 2, 706, "ROZPOCZNIJ", {
      fontFamily: "Arial, sans-serif",
      fontSize: "24px",
      color: "#f1ece4",
      backgroundColor: "#0a0d12",
      padding: { left: 58, right: 58, top: 20, bottom: 20 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    start.setStroke("#8e7448", 1);
    start.on("pointerover", () => start.setColor("#d9bf84"));
    start.on("pointerout", () => start.setColor("#f1ece4"));
    start.on("pointerdown", () => this.scene.start("ArenaScene"));

    this.add.text(width / 2, 1010,
      "NIKODEM SYGULSKI  •  KRZYSZTOF RÓŻYCKI  •  v0.20.0",
      {
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        color: "#8e887e",
        letterSpacing: 2,
      }).setOrigin(0.5);
  }
}
